import React from "react";
import { useLocation } from "react-router-dom";

const Header = () => {
  const location = useLocation();
  
  // Ne pas afficher le header sur les pages d'authentification, dashboard admin et boutique secrète
  const isAuthPage = location.pathname.includes('/admin/login') || 
                     location.pathname.includes('/admin/register') ||
                     location.pathname.includes('/admin/dashboard') ||
                     location.pathname.includes('/client-auth') ||
                     location.pathname.includes('/shop');
  
  if (isAuthPage) {
    return null;
  }
  
  return (
    <header>
    </header>
  );
};

export default Header;
